import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'

import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

import './View.scss'

const CLASS = 'insights-portal-editor-view'

const View = props => {
  const className = props.className || CLASS

  const editor = useMemo(() => props.editor || {}, [props.editor])

  const subject = useMemo(() => editor.data || {}, [editor.data])

  const wait = useMemo(() => 'uploading' === editor.state || false, [editor.state])

  const image = subject?.image || null

  const editorType = editor.type || ''

  const inputRef = useRef()

  const imageErrors = useMemo(() => editor.errors?.image || [], [editor.errors?.image])

  const originalSrc = useMemo(
    () =>
      image?.original?.path
        ? getImageAssetPath({
            width: 480,
            height: 480,
            path: image?.original?.path,
            filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT
          })
        : null,
    [image?.original?.path]
  )

  const inputChange = () => {
    if (!props.onEditorChange || !props.onImageUpload || !inputRef.current) {
      return
    }
    const file = inputRef.current.files && inputRef.current.files.length ? inputRef.current.files[0] : null
    if (!file) {
      return
    }
    const error = props?.onCheck('image', file) || null
    if (!error?.message?.length) {
      props.onImageUpload({ file })
    }
  }

  const uploadImage = () => {
    if (inputRef.current && inputRef.current.click) {
      inputRef.current.click()
    }
  }

  const waitComponent = wait ? (
    <div className={`${className}-wait`}>
      <i className={`icon-aytmfd-refresh ${className}-wait-icon`}></i>
      <div className={`${className}-wait-text`}>please wait</div>
    </div>
  ) : null

  const imageClass = `${className}-image`

  const pictureComponent = originalSrc ? <img src={originalSrc} className={imageClass} loading="lazy" /> : null

  const iconComponent = !wait ? (
    <div className={`${className}-upload`} onClick={uploadImage}>
      <i className={`icon-aytmfd-image ${className}-upload-icon`} />
      <div className={`${className}-upload-text`}>upload image</div>
    </div>
  ) : null

  const imageErrorComponent =
    !wait && imageErrors?.length ? (
      <div className={`${className}-error`} onClick={uploadImage}>
        {imageErrors.map((v, i) => (
          <div key={i} className={`${className}-error-text`} dangerouslySetInnerHTML={{ __html: v }} />
        ))}
      </div>
    ) : null

  const viewComponent = props.showImage ? (
    ['edit', 'change'].includes(editorType) ? (
      <div className={`${CLASS}-container`}>
        <input
          ref={inputRef}
          className={`${className}-upload-input`}
          type="file"
          name="assets"
          accept="image/*"
          onChange={inputChange}
        />
        {iconComponent}
        {waitComponent}
        {imageErrorComponent}
        {pictureComponent}
      </div>
    ) : (
      <div className={`${CLASS}-container`}>
        <i className={`icon-aytmfd-concept-portal-bold ${className}-empty-icon`} />
      </div>
    )
  ) : null

  return (
    <div className={`${className}${props.showImage ? '' : ` ${className}-hide`}`} style={props.style}>
      {viewComponent}
    </div>
  )
}

View.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  editor: PropTypes.object,
  showImage: PropTypes.any,
  onEditorChange: PropTypes.func,
  onImageUpload: PropTypes.func,
  onCheck: PropTypes.func
}

View.defaultProps = {
  showImage: true
}

export default View
